/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import './MessageDialog.styles.scss';

const MessageDialog = (props) => (
  <div className="cmp-messagedialog" onClick={(e) => { e.stopPropagation(); }}>
    <div className="cmp-messagedialog-content">
      <h3>
        <FormattedMessage {...props.title} />
      </h3>
      <p>
        <FormattedMessage {...props.message} />
      </p>

      <div className="button-group">
        {
          props.buttons.map((b, index) => (
            <button key={index} className="font-color-profile" onClick={(e) => { e.stopPropagation(); b.onClick(); }}>
              <FormattedMessage {...b.text} />
            </button>
          ))
        }
      </div>
    </div>
  </div>
);
MessageDialog.propTypes = {
  title: PropTypes.object,
  message: PropTypes.object,
  buttons: PropTypes.array,
};

export default MessageDialog;
